module.exports = {"btnCustomer":{"toolTip":"Kontrahent"},"btnPositions":{"toolTip":"Pozycje"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateComplaintMenu/translate.json
// module id = 1238
// module chunks = 0